import React from 'react'
import { connect } from 'react-redux'
import { groupBy } from 'lodash-es'
import { HolidayDetail, CrudEventEnum, Holiday, CrudActions } from 'api'
import { ActionsButtonProps } from 'view/components/datagrid'
import { ActionItem, SplitButtonDropdown } from 'view/components/menus'
import { NotificationActions, ShowDialogArgs, NotificationType } from 'store/notification'
import { getDateString } from 'utils'
import { Translation, Locale } from 'locale'

export interface HolidayActionsButtonProps extends ActionsButtonProps<HolidayDetail> {
  onShowDialog: (dialogArgs: ShowDialogArgs) => unknown
}

const mapStateToProps = null

const mapDispatchToProps = {
  onShowDialog: NotificationActions.showDialog
}

export class HolidayActionsButtonComponent extends React.Component<HolidayActionsButtonProps> {
  render() {
    const deleteItems = this.props.items.filter(item => this.canDeleteHoliday(item))

    const actions: ActionItem[] = [
      {
        label: this.getLabel(Translation.TC_ACTION_DELETE, deleteItems.length),
        onClick: () => this.handleDelete(deleteItems),
        enabled: deleteItems.length > 0
      }
    ]
    return <SplitButtonDropdown dataTestId={'HolidayActionsButton'} actions={actions} maxButtons={1} autoHideEllipsis={true} />
  }

  private getLabel = (baseLabel: Translation, count: number) => {
    const { isGroupRow } = this.props
    const countLabel = isGroupRow ? ` (${count})` : ``
    return `${Locale.translate(baseLabel)}${countLabel}`
  }

  private handleDelete = async (items: HolidayDetail[]) => {
    const titleText = Locale.translate(Translation.TC_PROMPT_TITLE_DELETE_HOLIDAY, { count: items.length })
    const messageText =
      items.length === 1
        ? Locale.translate(Translation.SC_PROMPT_MSG_DELETE_SINGLE_HOLIDAY, { date: `${items[0].holiday.currency} - ${items[0].date}` })
        : Locale.translate(Translation.SC_PROMPT_MSG_DELETE_MULTI_HOLIDAY, { count: items.length })

    const itemsByCurrency = groupBy(items, item => item.holiday.currency)

    const deleteActions = Object.values(itemsByCurrency).map(currencyItems => {
      const oldHoliday = currencyItems[0].holiday
      if (currencyItems.length === oldHoliday.holidays.length && this.canDeleteCurrency(currencyItems[0])) {
        return CrudActions.holidayDelete(oldHoliday.currency)
      } else {
        const excludeHolidays = currencyItems.map(item => getDateString(item.date))
        const newHoliday: Holiday = {
          ...oldHoliday,
          holidays: oldHoliday.holidays.filter(holiday => !excludeHolidays.includes(getDateString(holiday)))
        }
        return CrudActions.holidayUpsert(newHoliday)
      }
    })

    this.props.onShowDialog({
      type: NotificationType.Confirm,
      titleText,
      messageText,
      buttons: [Translation.TC_BUTTON_YES, Translation.TC_BUTTON_NO],
      defaultButton: Translation.TC_BUTTON_YES,
      cancelButton: Translation.TC_BUTTON_NO,
      responseMap: {
        [Translation.TC_BUTTON_YES]: deleteActions
      }
    })
  }

  private canDeleteHoliday = (item: HolidayDetail) => {
    return item.availableEvents.includes(CrudEventEnum.UPSERT)
  }

  private canDeleteCurrency = (item: HolidayDetail) => {
    return item.availableEvents.includes(CrudEventEnum.DELETE)
  }
}

export const HolidayActionsButton = connect(mapStateToProps, mapDispatchToProps)(HolidayActionsButtonComponent)
